<template>
  <main class="container">
    <div class="row h-100">
      <div class="content col-12">
        <div id="header-image">
          <img
            src="~/assets/images/history/Bilder_Geschichte_1270x415_01.jpg"
            alt="Bilder von alten Zeiten: Fotos vom Haupteingang der Bodmer AG und verschieden Kisten und Produkten."
          >
        </div>
        <generic-page-breadcrumb/>
        <h1>Bodmer AG - über {{ yearsSinceFoundingRounded }} Jahren Erfahrung mit Holz</h1>
        <div class="teaser-body">
          <blockquote>
            <span>&ldquo;</span>Die Bodmer AG ist ein schweizer Traditionsbetrieb. In ihrer {{ yearsSinceFounding }}-jährigen Geschichte arbeitete sie immer mit Holz.<span>&rdquo;</span>
          </blockquote>
          <p>Die Bodmer AG hat ihren Standort zentral im Mittelland an der Kantonsgrenze zwischen Aargau und Solothurn.</p>
          <p>Die 1905 gegründete Firma entwickelte sich im Lauf der Zeit, von einem Sägereibetrieb zu einem Holzverpackungsspezialisten.</p>
          <p>Dank gezielten, eigenfinanzierten Investitionen und einer konsequenten Abschreibungspolitik, konnten wir unsere Familienaktiengesellschaft auf gesunde Füsse stellen.</p>
          <p>Nebst unseren motivierten und engagierten Mitarbeitern steht ein moderner Maschinenpark im Einsatz, darunter auch zwei CNC gesteuerte Nagelcenter.</p>
          <table>
            <tbody>
              <tr>
                <td>1905</td>
                <td>
                  Gründung durch Julius Bodmer-Erb als Sägereibetrieb mit Holzhandlung in Niedergösgen. Schon bald werden nebenbei auch Kisten hergestellt.
                </td>
              </tr>
              <tr>
                <td>1932</td>
                <td>Übernahme durch die Söhne Emil und Werner Bodmer. Unter anderem werden für die Firma Bally Schuhkisten gefertigt und Lohnarbeiten übernommen.</td>
              </tr>
              <tr>
                <td>1937</td>
                <td>Umwandlung in E.&amp;W. Bodmer GmbH. Übrigens fast die erste GmbH in der Schweiz.</td>
              </tr>
              <tr>
                <td>1946</td>
                <td>
                  Max und Peter Bodmer werden alleinige Inhaber der Bodmer GmbH. Die ersten Jahre der Nachkriegszeit sind beschwerlich und voller Unsicherheit. Es werden vorwiegend Harassen, zuerst für Obst, später vor allem für Getränke produziert. Ein erster Jeep mit Anhänger wird gekauft.
                </td>
              </tr>
              <tr>
                <td>1960</td>
                <td>In den Sechziger Jahren wird eine Palettenstrasse zur Herstellung von EUR – Paletten installiert. Laufend werden die Produktions-und Lagergebäude den Bedürfnissen angepasst. Auch ein erster MAN-LKW mit 7.5 m Ladefläche und ein erster Seitenstapler werden erworben.</td>
              </tr>
              <tr>
                <td>1978</td>
                <td>
                  Nach dem tragischen Unfalltod von Max Bodmer, wird die GmbH in eine AG überführt.
                </td>
              </tr>
              <tr>
                <td>1980</td>
                <td>
                  Eintritt von Andreas Bodmer, mittlerweile die 4. Generation, in die Firma. Die Bodmer AG produziert nun mehrheitlich Kisten und Paletten, beispielsweise für Sprecher und Schuh.
                </td>
              </tr>
              <tr>
                <td>1983</td>
                <td>
                  Eine LKW-Rampe mit angrenzender Kranbahn wird gebaut. Einführung der EDV. Der Sägereibetrieb wird ein Jahr später definitiv eingestellt.
                </td>
              </tr>
              <tr>
                <td>1989</td>
                <td>
                  Kauf der ersten Portalangelmaschine zur Herstellung von Kisten.
                </td>
              </tr>
              <tr>
                <td>1994</td>
                <td>
                  Beschaffung des zweiten Nagelcenters. Die gesamten Daten der Auftragsbearbeitung können direkt in die Maschine eingelesen werden.
                </td>
              </tr>
              <tr>
                <td>1998</td>
                <td>
                  Totale Erneuerung der Informatik mit ERP XAL – Dynamics.
                </td>
              </tr>
              <tr>
                <td>2000</td>
                <td>
                  Übernahme der Packerei der Pfiffner Messwandler AG.
                </td>
              </tr>
              <tr>
                <td>2005</td>
                <td>
                  Die Firma feiert ihr 100 jähriges Bestehen.
                </td>
              </tr>
              <tr>
                <td>2009</td>
                <td>
                  Neuer Schwerlaststapler mit Partikelfilter neuester Technologie
                </td>
              </tr>
              <tr>
                <td>2010</td>
                <td>
                  QUM Zertifizierung ISO 9001 / 14001
                </td>
              </tr>
              <tr>
                <td>2010</td>
                <td>
                  Komplette Erneuerung der Zuschneiderei. Eintritt von Lukas und Tobias Frey in die Firma (5. Generation).
                </td>
              </tr>
              <tr>
                <td>2011</td>
                <td>
                  Kauf einer weiteren Portalnagelmaschine für Paletten. Auch der erste Webshop geht online (<b-link href="https://www.holzverpackung.ch">www.holzverpackung.ch</b-link>)
                </td>
              </tr>
              <tr>
                <td>2015</td>
                <td>
                  Kauf eines LKW’s mit 11 Metern Ladefläche. Die Firma beschäftigt inzwischen 35 Mitarbeiter.
                </td>
              </tr>
              <tr>
                <td>2018</td>
                <td>
                  Lukas und Tobias Frey-Bodmer erwerben die Bodmer AG.
                </td>
              </tr>
              <tr>
                <td>2019</td>
                <td>
                  Inbetriebnahme des Aussenlagers in Däniken.
                </td>
              </tr>
              <tr>
                <td>2021</td>
                <td>
                  Der neue Webshop geht online (<b-link href="/produkte/verpackung">bodmer.swiss</b-link>). Produkte können nach Mass konfiguriert und 3-dimensional dargestellt werden.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <static-gallery :images="images"/>
      </div>
    </div>
  </main>
</template>
<script>

import GenericPageBreadcrumb from "@/components/navigation/GenericPageBreadcrumb";
import StaticGallery from "@/components/gallery/StaticGallery";

const FOUNDING_YEAR = 1905;

export default {
  components: {
    StaticGallery,
    GenericPageBreadcrumb,
  },
  scrollToTop: true,
  data() {
    return {
      images: [
        {
          divClass: "grid-horizontal",
          src: "/images/history/Bilder_Geschichte_1270x415_02a.jpg",
          al: "Altes Bild des Hauptgebäudes der Bodmer AG.",
        },
        {
          src: "/images/history/Bilder_Geschichte_1270x415_02b.jpg",
          alt: "Alte Logos der Bodmer AG.",
        },
        {
          src: "/images/history/Bilder_Geschichte_1270x415_03a.jpg",
          alt: "Alter Flyer der Bodmer AG.",
        },
        {
          src: "/images/history/Bilder_Geschichte_1270x415_03b.jpg",
          alt: "Altes Lager mit geschichteten Holzplanken.",
          divClass: "grid-horizontal",
        },
      ],
    };
  },
  computed: {
    yearsSinceFounding() {
      return new Date().getFullYear() - FOUNDING_YEAR;
    },
    /** Auf 5er-Schritte abgerundet, damit "über X Jahren" auch vor dem Jahrestag stimmt. */
    yearsSinceFoundingRounded() {
      return Math.floor(this.yearsSinceFounding / 5) * 5;
    },
  },
  mounted() {
    if (process.client) {
      document.getElementById("scrollTarget").scrollIntoView();
    }
  },
};
</script>
